import React from 'react';
import useHealthPlanAppointment from '../../../../Modules/HealthPlan/Services/healthPlanAppointment.service';
import useTranslation from '../../../../Hooks/useTranslation';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
// @ts-ignore
import styles from './CalendarHealthPlanEventAppointmentInfo.module.scss';
import { getMomentDate } from '../../../../Utils/dates.util';
import { HealthPlanCode } from '../../../../Enums/HealthPlanCode.enum';

interface Props {
	healthPlanCode: HealthPlanCode;
}

const CalendarHealthPlanEventAppointmentInfo: React.FC<Props> = ({
	healthPlanCode,
}) => {
	const { getNextAppointmentInfo } = useHealthPlanAppointment();
	const { t } = useTranslation();
	const { getDateRangeByMonth } = useHealthPlanAppointment();
	const nextAppointment = getNextAppointmentInfo();
	const { healthPlanUser } = useHealthPlanContext();

	if (!nextAppointment || healthPlanCode != HealthPlanCode.DIABETES) {
		return <></>;
	}

	return (
		<div className={styles.plannedIn}>
			{t('component.appointmentDetail.meetingHasToBePlannedIn', {
				month: getDateRangeByMonth(
					getMomentDate(healthPlanUser?.activeFrom),
					nextAppointment?.extra?.month,
				),
			})}
		</div>
	);
};

export default CalendarHealthPlanEventAppointmentInfo;
